import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ value, max = 100, color = 'green', className = '' }) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
  
  const colorClasses = {
    green: 'bg-minecraft-green',
    blue: 'bg-minecraft-blue',
    red: 'bg-minecraft-red',
    orange: 'bg-minecraft-orange'
  };

  return (
    <div className={`w-full bg-gray-200 rounded-full h-4 ${className}`}>
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${percentage}%` }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className={`h-4 rounded-full ${colorClasses[color]}`}
      />
    </div>
  );
};

export default ProgressBar;